module.exports = __webpack_public_path__ + "img/gb9115_18_b.prt.2df2ee58.jpg";